import React from 'react';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { ErrorBoundary } from '@confluence/error-boundary/entry-points/ErrorBoundary.ts';
import { isStableUIEnabledForTests } from '@confluence/e2e-url-override/entry-points/isStableUIEnabledForTests.ts';
import { CrossJoinNudgesWithFlags } from '@confluence/cross-join-nudges';

export const GrowthComponentsLoader = (): React.JSX.Element | null => {
	if (isStableUIEnabledForTests()) {
		return null;
	}

	return (
		<>
			<ErrorBoundary
				attribution={Attribution.GROWTH_PUMA}
				attributes={{
					errorBoundaryId: 'GlobalComponents-GrowthPuma',
				}}
			>
				<CrossJoinNudgesWithFlags />
			</ErrorBoundary>
		</>
	);
};
